__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@dac/demand_and_capacity";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@automapper/core", "8.8.1", () => (__webpack_require__.e(7872).then(() => (() => (__webpack_require__(7872))))));
			register("@automapper/pojos", "8.8.1", () => (Promise.all([__webpack_require__.e(2102), __webpack_require__.e(9110)]).then(() => (() => (__webpack_require__(9110))))));
			register("@dsc/components", "2.4.0", () => (Promise.all([__webpack_require__.e(8642), __webpack_require__.e(7788), __webpack_require__.e(3121), __webpack_require__.e(8848), __webpack_require__.e(6480)]).then(() => (() => (__webpack_require__(8642))))));
			register("@element-plus/icons-vue", "2.3.1", () => (Promise.all([__webpack_require__.e(8647), __webpack_require__.e(4774)]).then(() => (() => (__webpack_require__(8647))))));
			register("@element-plus/icons-vue", "2.3.2", () => (Promise.all([__webpack_require__.e(3852), __webpack_require__.e(4774)]).then(() => (() => (__webpack_require__(3852))))));
			register("@element-plus/icons-vue", "2.3.2", () => (Promise.all([__webpack_require__.e(8548), __webpack_require__.e(4774)]).then(() => (() => (__webpack_require__(8548))))));
			register("@scp/frontend-common", "1.14.2", () => (Promise.all([__webpack_require__.e(9970), __webpack_require__.e(9996), __webpack_require__.e(7698), __webpack_require__.e(6426)]).then(() => (() => (__webpack_require__(9970))))));
			register("@vue/apollo-composable", "4.2.2", () => (Promise.all([__webpack_require__.e(9211), __webpack_require__.e(5933), __webpack_require__.e(4907)]).then(() => (() => (__webpack_require__(5933))))));
			register("@vueuse/core", "10.11.1", () => (Promise.all([__webpack_require__.e(3115), __webpack_require__.e(4907)]).then(() => (() => (__webpack_require__(3115))))));
			register("@vueuse/core", "12.0.0", () => (Promise.all([__webpack_require__.e(3027), __webpack_require__.e(2317)]).then(() => (() => (__webpack_require__(3027))))));
			register("@vueuse/core", "9.13.0", () => (Promise.all([__webpack_require__.e(4984), __webpack_require__.e(4907)]).then(() => (() => (__webpack_require__(4984))))));
			register("element-plus", "2.10.7", () => (Promise.all([__webpack_require__.e(6429), __webpack_require__.e(8204), __webpack_require__.e(4774), __webpack_require__.e(245), __webpack_require__.e(7698)]).then(() => (() => (__webpack_require__(8204))))));
			register("element-plus", "2.13.7", () => (Promise.all([__webpack_require__.e(6429), __webpack_require__.e(7631), __webpack_require__.e(3121), __webpack_require__.e(9127)]).then(() => (() => (__webpack_require__(7631))))));
			register("exceljs", "4.4.0", () => (__webpack_require__.e(4974).then(() => (() => (__webpack_require__(4974))))));
			register("graphql", "16.14.2", () => (__webpack_require__.e(1547).then(() => (() => (__webpack_require__(1547))))));
			register("pinia", "2.3.1", () => (Promise.all([__webpack_require__.e(810), __webpack_require__.e(4907)]).then(() => (() => (__webpack_require__(810))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(9308).then(() => (() => (__webpack_require__(9308))))));
			register("vue-i18n", "10.0.5", () => (() => (__webpack_require__(1999))), 1);
			register("vue-i18n", "11.4.12", () => (() => (__webpack_require__(9405))), 1);
			register("vue-router", "4.6.4", () => (() => (__webpack_require__(4965))), 1);
			register("vue", "3.5.43", () => (() => (__webpack_require__(785))), 1);
			initExternal(7473);
			initExternal(2590);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};